export const copy = {
  en: {
    nav: {
      machines: "Machines",
      why: "Why SQB",
      useCases: "Use Cases",
      team: "Team",
      contact: "Contact",
      cta: "Let's talk",
    },
    hero: {
      eyebrow: "Autonomous retail systems — Bucharest, RO",
      lines: ["WE'LL PICK", "IT FOR YOU."],
      sub: "AI-powered, robot-operated autonomous convenience stores. Open 24/7, staff-free, anywhere your customers are.",
      ctaPrimary: "Explore the machines",
      ctaSecondary: "Get in touch",
      chips: ["24/7 NON-STOP", "UP TO 400 SKUs", "ONLY 15 M²"],
      scroll: "Scroll",
    },
    marquee: ["WE'LL PICK IT FOR YOU", "AI-POWERED", "ROBOT-OPERATED", "OPEN 24/7", "ZERO STAFF", "ENABLING CONVENIENCE ANYWHERE"],
    videoSection: {
      kicker: "In action",
      title: "Watch the Squirrel Bot work.",
      caption: "Proximart — the first AI-powered, robot-operated automated store in Romania. This is our production-ready store making money, unmanned.",
      id: "gW_Gafi6z4g",
    },
    manifesto: {
      kicker: "Why SQB",
      title: "The 24/7 convenience gap is real. We close it with robots.",
      intro: "Staffing costs and limited opening hours are retail's biggest problems. Labour shortage, high turnover, rising utilities — while 60% of rural communities stay underserved and very few stores never close. Our answer: an unmanned, automated, robot-operated store.",
      chapters: [
        { n: "01", title: "Cost Optimization", body: "Cut labour, rent and setup costs — over 90% reduction in staffing costs, minimized losses, and one good manager overseeing restocking for up to 30 stores." },
        { n: "02", title: "Open 24/7", body: "Operate continuously without staff. Every night, weekend and holiday becomes a sales opportunity instead of a closed door." },
        { n: "03", title: "Enhanced Customer Service", body: "24/7 access to products, consistent service quality, quick self-checkout — built for on-the-go and impulse buying habits." },
        { n: "04", title: "Easy for Everyone", body: "An intuitive touchscreen interface for browsing and selecting products. If you can use a phone, you can shop at SQB." },
      ],
      stats: [
        { v: "−90%", l: "staffing costs" },
        { v: "24/7", l: "always open" },
        { v: "1 : 30", l: "manager-to-store ratio" },
        { v: "3 mo", l: "typical lead time" },
      ],
    },
    products: {
      kicker: "The Machines",
      title: "Hardware that sells.",
      items: [
        {
          id: "container",
          name: "SQB Store",
          tag: "The outdoor solution",
          desc: "A 7.2 × 2.5 m always-open store that revolutionizes retail, FMCG, pharmacy and real estate. Climate-controlled, insulated for fresh and cold products, placed anywhere in the world — from busy urban centres to quiet remote places, without any staff presence.",
          specs: ["7.2 × 2.5 M", "≤ 400 SKUs", "230/400 V", "1500 KG"],
          idealFor: ["Proximity retail", "Pharmacy", "Gas stations", "Factories"],
          img: "/assets/store-render.png",
        },
        {
          id: "store",
          name: "Customer's Own Venue",
          tag: "Your venue, our robot",
          desc: "We transform your existing space into a fully automated store, open 24/7. At its heart walks the Squirrel Bot — our AI-powered robot using 3D vision, infrared and pressure sensor fusion to gently pick anything from 2 cm to 30 cm, fragile items included, and deliver it to the pickup door.",
          specs: ["CUSTOM LAYOUT", "LIVE WMS DATA", "LOYALTY WEBAPP", "AGE VERIFICATION"],
          idealFor: ["Retailers", "Campuses", "Hospitals", "Transport hubs"],
          img: null,
        },
      ],
      idealLabel: "Ideal for",
    },
    specs: {
      kicker: "The Specs",
      items: [
        ["UPTIME", "24/7/365"],
        ["CAPACITY", "≤ 400 SKUs"],
        ["BASKET", "6 KG"],
        ["PRODUCT SIZE", "2–30 CM"],
        ["FOOTPRINT", "15 M²"],
        ["SHELVING", "8 M LINEAR"],
        ["PAYMENT", "100% CARD"],
        ["VISION", "3D + IR + PRESSURE"],
        ["LEAD TIME", "3 MONTHS"],
        ["POWER", "230/400 V"],
      ],
    },
    useCases: {
      kicker: "Where it works",
      title: "Convenience, anywhere people need things.",
      blocks: [
        { title: "Petrol & EV Stations", body: "Future-proof your station for fossil and electric drivers alike — a futuristic, profitable service hub open around the clock.", img: "/assets/usecase-petrol.png", big: true },
        { title: "Car Washes", body: "Turn waiting time into revenue — 24/7 additional sales from traffic you already have, with accelerated ROI.", img: "/assets/usecase-carwash.png" },
        { title: "Gated Communities", body: "The 50-meter barrier: hyper-proximity keeps residents in the family, placed on private land where full-sized stores fail.", img: "/assets/scene-campus.jpg" },
        { title: "Rural & Underserved", body: "60% of rural communities are underserved. Micro-market economics finally work when you don't pay five salaries.", img: "/assets/usecase-rural.png" },
        { title: "Healthcare & Campus", body: "Essentials within reach for staff and visitors — around the clock, without a single shift.", img: "/assets/scene-hospital.jpg" },
      ],
    },
    team: {
      kicker: "The People",
      title: "Built by operators.",
      members: [
        { name: "Victor Tanvuia", role: "Co-founder & CTO", bio: "+20 years in software. An all-round technical mind with a long entrepreneurial background, retail included.", img: "/assets/victor.jpg" },
        { name: "Alexandra Boros", role: "Co-founder & CMO", bio: "+10 years at Value Retail. Marketing and partnerships for El Corte Inglés and UnionPay International, to name a few.", img: "/assets/alexandra.jpg" },
      ],
    },
    contact: {
      kicker: "Contact",
      title: "Let's disrupt convenience together, one automated store at a time.",
      name: "Name",
      email: "Email",
      company: "Company",
      message: "Message",
      messagePh: "Tell us about your location and what you'd like to sell…",
      submit: "Send message",
      sending: "Sending…",
      success: "Message sent — we'll get back to you shortly.",
      error: "Something went wrong. Please email us directly.",
      callUs: "Call us",
      writeUs: "Write to us",
    },
    footer: {
      rights: "© 2026 SQB Robotics. All rights reserved.",
      top: "Back to top",
    },
  },
  ro: {
    nav: {
      machines: "Mașini",
      why: "De ce SQB",
      useCases: "Cazuri de utilizare",
      team: "Echipă",
      contact: "Contact",
      cta: "Hai să vorbim",
    },
    hero: {
      eyebrow: "Sisteme de retail autonom — București, RO",
      lines: ["LE ALEGEM NOI", "PENTRU TINE."],
      sub: "Magazine de proximitate autonome, conduse de AI și operate robotic. Deschise 24/7, fără personal, oriunde sunt clienții tăi.",
      ctaPrimary: "Descoperă mașinile",
      ctaSecondary: "Contactează-ne",
      chips: ["NON-STOP 24/7", "PÂNĂ LA 400 SKU", "DOAR 15 M²"],
      scroll: "Derulează",
    },
    marquee: ["LE ALEGEM NOI PENTRU TINE", "CONDUS DE AI", "OPERAT ROBOTIC", "DESCHIS 24/7", "ZERO PERSONAL", "CONVENIENCE ORIUNDE"],
    videoSection: {
      kicker: "În acțiune",
      title: "Vezi Squirrel Bot la treabă.",
      caption: "Proximart — primul magazin automat din România condus de AI și operat robotic. Un magazin gata de producție care câștigă bani fără personal.",
      id: "gW_Gafi6z4g",
    },
    manifesto: {
      kicker: "De ce SQB",
      title: "Golul de convenience 24/7 e real. Noi îl acoperim cu roboți.",
      intro: "Costurile cu personalul și programul limitat sunt cele mai mari probleme ale retailului. Lipsa forței de muncă, fluctuația mare, utilitățile scumpe — în timp ce 60% dintre comunitățile rurale rămân deservite insuficient și foarte puține magazine nu se închid niciodată. Răspunsul nostru: un magazin fără personal, automatizat, operat robotic.",
      chapters: [
        { n: "01", title: "Optimizarea costurilor", body: "Reduci costurile cu personalul, chiriile și amenajarea — peste 90% economie la costurile de personal, pierderi minimizate, iar un singur manager bun poate supraveghea aprovizionarea a până la 30 de magazine." },
        { n: "02", title: "Deschis 24/7", body: "Funcționează continuu, fără personal. Fiecare noapte, weekend sau sărbătoare devine o oportunitate de vânzare, nu o ușă închisă." },
        { n: "03", title: "Experiență superioară", body: "Acces non-stop la produse, calitate constantă a serviciului, self-checkout rapid — gândit pentru cumpărăturile din mers și cele impulsive." },
        { n: "04", title: "Ușor pentru oricine", body: "O interfață tactilă intuitivă pentru răsfoirea și alegerea produselor. Dacă știi să folosești un telefon, știi să cumperi de la SQB." },
      ],
      stats: [
        { v: "−90%", l: "costuri de personal" },
        { v: "24/7", l: "mereu deschis" },
        { v: "1 : 30", l: "manageri la magazine" },
        { v: "3 luni", l: "timp de livrare" },
      ],
    },
    products: {
      kicker: "Mașinile",
      title: "Hardware care vinde.",
      items: [
        {
          id: "container",
          name: "SQB Store",
          tag: "Soluția de exterior",
          desc: "Un magazin mereu deschis de 7.2 × 2.5 m care revoluționează retailul, FMCG-ul, farmaciile și imobiliarele. Climatizat, izolat pentru produse proaspete și reci, poate fi amplasat oriunde în lume — din centre urbane aglomerate până în locuri liniștite și izolate, fără nicio prezență umană.",
          specs: ["7.2 × 2.5 M", "≤ 400 SKU", "230/400 V", "1500 KG"],
          idealFor: ["Retail de proximitate", "Farmacii", "Benzinării", "Fabrici"],
          img: "/assets/store-render.png",
        },
        {
          id: "store",
          name: "Spațiul Propriu al Clientului",
          tag: "Spațiul tău, robotul nostru",
          desc: "Transformăm spațiul tău existent într-un magazin complet automat, deschis 24/7. În centrul său „umblă” Squirrel Bot — robotul nostru cu AI care folosește camere 3D, infraroșu și senzori de presiune pentru a ridica delicat orice produs de la 2 cm la 30 cm, inclusiv articole fragile, și a-l livra la ușa de ridicare.",
          specs: ["LAYOUT PERSONALIZAT", "DATE WMS LIVE", "WEBAPP DE LOIALITATE", "VERIFICARE VÂRSTĂ"],
          idealFor: ["Retaileri", "Campusuri", "Spitale", "Noduri de transport"],
          img: null,
        },
      ],
      idealLabel: "Ideal pentru",
    },
    specs: {
      kicker: "Specificații",
      items: [
        ["FUNCȚIONARE", "24/7/365"],
        ["CAPACITATE", "≤ 400 SKU"],
        ["COȘ", "6 KG"],
        ["DIM. PRODUS", "2–30 CM"],
        ["AMPRENTĂ", "15 M²"],
        ["RAFTURI", "8 M LINIARI"],
        ["PLATĂ", "100% CARD"],
        ["VIZIUNE", "3D + IR + PRESIUNE"],
        ["LIVRARE", "3 LUNI"],
        ["ALIMENTARE", "230/400 V"],
      ],
    },
    useCases: {
      kicker: "Unde funcționează",
      title: "Convenience oriunde au oamenii nevoie de ceva.",
      blocks: [
        { title: "Benzinării & stații EV", body: "Pregătește-ți stația pentru viitor, pentru șoferii de mașini termice și electrice deopotrivă — un hub de servicii futurist și profitabil, deschis non-stop.", img: "/assets/usecase-petrol.png", big: true },
        { title: "Spălătorii auto", body: "Transformă timpul de așteptare în venit — vânzări suplimentare 24/7 din traficul pe care deja îl ai, cu ROI accelerat.", img: "/assets/usecase-carwash.png" },
        { title: "Comunități rezidențiale", body: "Bariera de 50 de metri: hiper-proximitatea păstrează rezidenții „în familie”, pe teren privat, acolo unde marile magazine nu sunt rentabile.", img: "/assets/scene-campus.jpg" },
        { title: "Rural & zone deservite insuficient", body: "60% dintre comunitățile rurale sunt deservite insuficient. Economia micro-piețelor funcționează în sfârșit când nu plătești cinci salarii.", img: "/assets/usecase-rural.png" },
        { title: "Sănătate & campusuri", body: "Produsele esențiale la îndemâna personalului și a vizitatorilor — non-stop, fără niciun tur de schimb.", img: "/assets/scene-hospital.jpg" },
      ],
    },
    team: {
      kicker: "Echipa",
      title: "Construit de oameni de teren.",
      members: [
        { name: "Victor Tanvuia", role: "Cofondator & CTO", bio: "Peste 20 de ani în software. Un tehnician desăvârșit, cu un lung parcurs antreprenorial, inclusiv în retail.", img: "/assets/victor.jpg" },
        { name: "Alexandra Boros", role: "Cofondatoare & CMO", bio: "Peste 10 ani la Value Retail. Marketing și parteneriate pentru El Corte Inglés și UnionPay International, printre altele.", img: "/assets/alexandra.jpg" },
      ],
    },
    contact: {
      kicker: "Contact",
      title: "Hai să reinventăm convenience-ul împreună, câte un magazin automat odată.",
      name: "Nume",
      email: "Email",
      company: "Companie",
      message: "Mesaj",
      messagePh: "Spune-ne despre locația ta și ce ai vrea să vinzi…",
      submit: "Trimite mesajul",
      sending: "Se trimite…",
      success: "Mesaj trimis — revenim în cel mai scurt timp.",
      error: "Ceva nu a mers. Scrie-ne direct pe email.",
      callUs: "Sună-ne",
      writeUs: "Scrie-ne",
    },
    footer: {
      rights: "© 2026 SQB Robotics. Toate drepturile rezervate.",
      top: "Înapoi sus",
    },
  },
};
